export function isLibraryOrganization(organizationId) {
    return organizationId === process.env.REACT_APP_LIBRARY_ORGANIZATION_ID;
}